<template>
  <div>

    <div class="card">
      <div class="card-header">
        <h4 class="card-title subject">BattingOrder</h4>
        <div class="card-title righter lsetting">
          <a @click="editjun=(editjun==setting_open ? -1 : setting_open);" class="underline_link">
              <img src="../assets/setting.svg" width="22" height="22">
          </a>
        </div>
        <!--
        <div class="righter">DH<toggle-button @change="myDataVariable"></toggle-button></div>
        -->
      </div>
      <div v-if="editjun==setting_open" class="card-body filterbox">
        <div>
          <b class="headline">各種設定</b>
        </div>
        <div>
          <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="shuse"
            :checked="SH_use" @change="updateCheck('SH_use')"
            >
            <label class="custom-control-label" for="shuse">送りバント使用</label>
          </div>
          <hr style="margin: 0.25em;border-bottom: 2px solid #606266;"><!--<div></div>-->
          <div>
            CSVエクスポート
            <label>
            <div class="btn btn-primary rounded-1" @click="downloadLineUpCSV()">
              ダウンロード
            </div>
            </label>
          </div>
          <div>
            CSVインポート
            <label>
            <span class="btn page-link text-dark d-inline-block">
              ファイル選択
              <input @change="fileChange" type="file" id="file_input_expense" name="file_input_expense"
              accept=".csv" style="display:none">
            </span>
            </label>
          </div>
        </div>
      </div>
      <draggable tag="ul" v-model="LineUp" :group="{ name: 'items'}" :animation="30" handle='.handle'
      :scroll-sensitivity="100"
      :force-fallback="true"
      >
      <li class="item " v-for="(item, index) in LineUp" :key="uuid(item) + 'l.' + index"
      style="background-color: #f7f9fa;"
      >
        <div class="handle head">
          <div class=" subject">
            <span v-if="index<9">{{index + 1}}番:</span>
            <span v-else>控え:</span>
            {{LineUp[index].name}}
            打率{{printAVG(calcRecord('AVG', LineUp[index]), 3)}}
            {{LineUp[index].HR}}本
          </div>
          <div class="righter"><img src="../assets/dragg.svg" width="16" height="16"></div>
        </div>
        <div style="margin:1% 0px 0px;">
          <div class="subject bars">
            <div class="bargray"></div>
            <div class="slgbar"
            v-bind:style="{ width: WidthBar(LineUp[index], 'SLG') + 'px' }"></div>
            <div style="margin:1px 0px 0px;"></div>
            <div class="bargray"></div>
            <div class="obpbar"
            v-bind:style="{ width: WidthBar(LineUp[index], 'OBP') + 'px' }"></div>
          </div>
          <div class="righter">
            <a v-if="false"
            :value="LineUp[index].lock" @click="LineUp[index].lock=!LineUp[index].lock">
            <span v-if="LineUp[index].lock"><img src="../assets/security.svg" width="20" height="20"></span>
            </a>
            <button type="button" class="btn py-1"
            v-bind:class="{'btn-info':editjun==index, 'btn-outline-info':editjun!=index}"
            v-on:click="(editjun==index ? editjun=-1: editjun=index)"
            >{{editjun==index ? "Close" : "Edit"}}</button>
            <button type="button" class="btn btn-outline-info px-1 py-1"
            v-on:click="UpDnLineup(index, false)" :disabled="(index == 0)">Up</button>
            <button type="button" class="btn btn-outline-info px-1 py-1"
            v-on:click="UpDnLineup(index, true)" :disabled="(index == LineUp.length-1)">Dn</button>
            <button type="button" class="btn btn-outline-danger px-1 py-1"
            v-on:click="DelLineup(index)" :disabled="(index == LineUp.length-1) && LineUp.length<=9">Del</button>
          </div>
          <div v-if="index==editjun" style="border-top: 1px solid #CCC;">
          </div>
        </div>
        <div v-if="index==editjun" >
          <div class="form-row">
            <div class="col-md-4 form-inline"
              v-for="(rec, i) in InputRecordList" :key="i">
              <label :for="rec">{{RecordName(rec)}}</label>
              <input class="col-md-8 form-control"
              ref="focusThis" @click="$refs.focusThis[i].select()"
              :value="LineUp[editjun][rec]" @change="updateRecord($event.target.value,editjun, rec)"
              tabindex=i />
            </div>
          </div>
          <div v-if="SH_flag" class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="shon"
            :checked="LineUp[editjun]['SH_play']" @change="updateRecord(!parseBoolean(LineUp[editjun]['SH_play']), editjun, 'SH_play')"
            >
            <label class="custom-control-label" for="shon">犠打</label>
          </div>
          <div v-if="SH_flag && LineUp[editjun]['SH_play']" class="card card-body">
            <div class="form-row form-inline">
              <div class="col-4 form-row form-inline">
                <label>成功率</label>
                <input class="col-md-4 form-control"
                :value="LineUp[editjun]['SH_rate']" @change="updateRecord($event.target.value,editjun, 'SH_rate')"/>
                %
              </div>
              <div class="col-4 form-row form-inline">
                <label>企図率</label>
                <input class="col-md-4 form-control"
                :value="LineUp[editjun]['SH_plan']" @change="updateRecord($event.target.value,editjun, 'SH_plan')"/>
                %
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-4 form-inline"
                v-for="(ro, i) in SH_OutList" :key="ro">
                <div class="custom-control custom-switch">
                  <input  type="checkbox" class="custom-control-input form-control"
                  :checked="LineUp[editjun]['SH_out'][ro]"
                  :id="'ro-'+ro"
                  @change="UpdateObj(parseBoolean(!LineUp[editjun]['SH_out'][ro]),
                  editjun, 'SH_out', ro)"
                  />
                <label class="custom-control-label" :for="'ro-'+ro">{{Str_OutRun(ro)}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      </draggable>
    </div>
  </div>
</template>

<script>
import Mixin from '../mixins/utility'
import draggable from 'vuedraggable'

export default {
mixins: [Mixin],
  name: "dnd",
  components: { draggable },
  computed: {
    LineUp:{
      get() {
        return this.$store.state.LineUp
      },
      set(val) {
        while(val.length >= 20) {
          for(let l = val.length - 1;l >= 0;l--) {
            if(val[l].lock == false){
              val.splice(l, 1);break;
            }
          }
        }
        val.some((d, index) => {
          d.jun = index
          delete d.index
        })
        this.$store.commit('updateValue', {vals: val, keyname: 'LineUp'})
      }
    },
    WidthBar() {
      return function (r, os) {
        const para = this.calcRecord(os == 'SLG' ? 'ISOP' : 'OBP', r)
        const k = {
          SLG: [1150, 0.020, 0.82],
          OBP: [170, 0.200, 1.3]
        }
        let rpara = k[os][0] * (para - k[os][1])
        if(rpara <= 0 || Number.isFinite(rpara) == false)return 1
        rpara = Math.pow(rpara, k[os][2]) * 1.30
        return Math.max(Math.min(rpara, 180), 1)
      }
    },
    inputlist() {
      return this.InputRecordList.concat(['SH_play', 'SH_rate', 'SH_plan', 'SH_out']);
    } 
  },
  data () {
    return {
      LockDajun: [],
      editjun: -1,
      setting_open: 334,
    }
  },
  methods: {
    updateCheck (keyname) {
      this.$store.commit('updateValue', {vals: this.$store.state[keyname] === false, keyname: keyname})
    },
    UpDnLineup(jun, dn) {
      function swap(a,x,y){
        a[x]=[a[y],a[y]=a[x]][0];
        return a;
      }
      let ls = this.LineUp.slice()
      const to = jun + (dn ? 1 : -1)
      ls = swap(ls, jun, to)
      //if(ls[jun].lock == false && ls[to].lock == false)
      this.$store.commit('updateValue', {vals: ls, keyname: 'LineUp'})
    },
    DelLineup(jun) {
      let ls = this.LineUp.slice()
      ls.splice(jun, 1)
      if(ls.length < 9)
      ls.push(this.EmptyPlayer(jun))
      //if(ls[jun].lock == false && ls[to].lock == false)
      this.$store.commit('updateValue', {vals: ls, keyname: 'LineUp'})
    },
    updateCheck (keyname) {
      this.$store.commit('updateValue', {vals: this.$store.state[keyname] === false, keyname: keyname})
    },
    updateRecord (vals ,jun, keyname) {
      let ls = this.LineUp.slice()
      let r = Object.assign({}, ls[jun])
      r[keyname] = vals
      if(keyname == 'SH_play') {
        console.log(r[keyname])
        r[keyname] = this.parseBoolean(vals)
        console.log(r[keyname])
      }else
      if(keyname != 'SH_play' && keyname != 'name') {
        r[keyname] = Number(this.hankaku2Zenkaku(vals))
        r[keyname] = Math.abs(r[keyname])
      }
      ls[jun] = r
      this.$store.commit('updateValue', {vals: ls, keyname: 'LineUp'})
    },
    UpdateObj (vals, jun, objname, keyname) {
      let ls = this.LineUp.slice()
      let r = Object.assign({}, ls[jun][objname])
      r[keyname] = vals
      ls[jun][objname] = r
      this.$store.commit('updateValue', {vals: ls, keyname: 'LineUp'})
    },
    fileChange: function(e) {
      let workers = [];
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.readAsText(file);
      reader.onload = () => {
        let lines = reader.result.split("\n");
        lines.shift();
        let linesArr = [];
        for (let i = 0; i < lines.length; i++) {
          linesArr[i] = lines[i].split(",");
          this.EmptyPlayer(i)
          this.inputlist.some((r, index) => {
            if(index > linesArr[i].length || linesArr[i].length < 10 || i >= 20)return true;
            else {
              if(r == 'SH_out'){
                this.SH_OutList.some((re, rindex) => {
                  this.UpdateObj(this.parseBoolean(linesArr[i][index + rindex]), i, 'SH_out', re) 
                })
                return true
              }else{
                this.updateRecord(linesArr[i][index] , i, r)
              }
            }
          })
        }
        console.log(workers)
      };

      // onloadはreadAsBinaryStringでファイルを読み込んだ後に実行されます.
    },
    downloadLineUpCSV () {
      var csv = '\ufeff'
      const filename = 'order.csv'
      const lineup = this.LineUp
      
      this.inputlist.some(rec => {
        if(rec == 'SH_out') {
          this.SH_OutList.some(re => { csv += re + ',' })
        }else{
          csv += rec + ','
        }
      })
      csv += '\n'

      lineup.forEach((batter, index) => {
        let line = '';//
        this.inputlist.some(rec => {
          if(rec == 'SH_out') {
            Object.values(batter[rec]).some(re => { line += re + ','})
          }else{
            line += batter[rec] + ','
          }
        })
        line += '\n'
        csv += line
      })
      
      let blob = new Blob([csv], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    }
  }
}
</script>

<style scoped>
.item {
margin: 2px;
padding: 4px;
border: 1px solid #aaa;
border-radius: 4px;
background-color: #ffffff;
}
.handle:hover {
cursor: grab;
}
.handle:active {
cursor: grabbing;
}
ul {
  list-style-type: none;
}
li {
  padding: 4px;
  border: solid #ddd 1px;
}
.head {
  padding: 0.05em 0.1em;/*上下 左右の余白*/
  background: transparent;/*背景透明に*/
  border-left: solid 5px #138496;/*左線*/

  background: linear-gradient(transparent 95%, #138496 70%);
}
.slgbar {
  background-color: palevioletred;
  height: 1em;
  border: 0px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;

  position: relative;
}
.obpbar {
  background-color: mediumaquamarine;
  height: 1em;
  border: 0px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  
  position: relative;
}
.bargray {
  background-color: #ccc;
  position: absolute;
  height: 1em;
  width: 180px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
.bars {
  line-height: 0px;

  position: relative; /* IE is dumb */
}
.lsetting {
	bottom: 0;
  color: white;
}
</style>
<style>
.subject {
   text-align: left;  /* 文章を左寄せする(※) */
   float: left;     /* 左端に寄せて、後続を右側へ回り込ませる */
}
.righter {
   text-align: right; /* 文章を右寄せする */
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::before {
    background-color:rgba(23, 162, 183, 1);
    border-color: rgba(13, 132, 163, 1);
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 183, 0.25);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {

}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  background-color: rgba(145, 191, 199, 1);
  border-color: rgba(145, 191, 199, 1);
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: rgba(23, 162, 183, 1);
}
  .custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
    color: rgba(23, 162, 183, 1);
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: red;
  background-color: red;
}
p.borderbottom {
   border-bottom: 1px solid red;
}
</style>




// WEBPACK FOOTER //
// src/components/lineup.vue